import React, { useState, useEffect } from "react";
import { Label, Row, Col, Input, Button, FormGroup, InputGroup, InputGroupText } from "reactstrap";
import useAxios from 'hooks/useAxios';
import { Formik } from 'formik';
import { default as ReactSelect } from "react-select";
import { CustomOption, LimitedChipsContainer } from 'components/Options';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment/moment";
import Calendar from "assets/icon/calendar-icon.svg";
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';

let initialOptions = [
    { value: 'selectAll', label: 'Select All' },
];

let statusdata = [];
let SearchButton = true;
let hasDatePopupOpen = false;
let Startingyear;
let endingyear;
let StartingMonth;
let endingMonth;
let Statusdropdown = true;

const SearchContainer = (props) => {

    const API = useAxios();
    const {
        onSearch,
        onReset,
        cleartabledata,
        manvalBulk,
    } = props;
    const [monthid, setmonth] = useState(endingMonth);
    const [yearvalue, setyear] = useState(endingyear);
    const [invoiceid, setInvoiceid] = useState(1);
    const [selectedOptionCE, setOptSelectedCE] = useState({ optionSelected: [] });
    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedyear, setSelectedYear] = useState(new Date());
    const [maxmont, setmaxmonth] = useState(new Date());
    const [Status, setStatus] = useState(-1);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [coveredentitesId, setCoveredentitesIds] = useState([]);
    const [coveredentitydata, setCoveredentitydata] = useState(initialOptions);

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        };

        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        };
    };

    const selectedinvoicetypeoptions = [
        { id: '1', label: 'Financial Management' },
        { id: '2', label: 'Invoice' },
    ];

    const { profile } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const { isSuperAdmin } = profile || {};

    useEffect(() => {
        fetchCoveredentity();
        ShowStatus()
    }, []);

    useEffect(() => {
        fetchStatus();
    }, []);

    useEffect(() => {
        fetchGetEndingYearMonth();
    }, []);

    useEffect(() => {
        fetchStartingYearMonth();
    }, []);

    const fetchStartingYearMonth = async () => {

        setLoading(true);
        try {
            const { data } = await API.get('/search/startingyearmonth', {
                hasDefaultURL: false,
            });
            if (data) {
                Startingyear = data[0].year;
                StartingMonth = data[0].month;
            };
            setLoading(false)
        } catch (err) {
        };
    };

    const ShowStatus = async () => {

        if (isSuperAdmin == "True") {
            Statusdropdown = true
        }
        else {
            Statusdropdown = false
        }
    };

    const fetchGetEndingYearMonth = async () => {

        setLoading(true)
        try {
            const { data } = await API.get('/search/endingyearmonth', {
                hasDefaultURL: false,
            });
            if (data) {

                endingyear = data[0].year;
                endingMonth = data[0].month;
                setSelectedYear(new Date(endingyear, 11, 28))
                setyear(endingyear);
                setmonth(endingMonth);
                setSelectedDate(new Date(endingyear, endingMonth - 1, 28))
                setmaxmonth(new Date(endingyear, endingMonth - 1, 28))
            };
            setLoading(false)
        } catch (err) {
        };
    };

    const fetchCoveredentity = async () => {
        setLoading(true);
        try {
            const { data } = await API.get(`/search/coveredentities`, {
                hasDefaultURL: false,
            });
            if (data) {

                initialOptions = [
                    { value: 'selectAll', label: 'Select All' },
                ];
                var arr = initialOptions;
                for (var x in data) {
                    arr.push({ "value": data[x].ceid, "label": data[x].ceName });
                };
                setCoveredentitydata(arr);
            }
            else {
                setCoveredentitydata([])
            }
        } catch (err) {
            setLoading(false);
        };
    };

    const fetchStatus = async () => {

        statusdata = [];
        setLoading(true);
        try {
            const { data } = await API.get(`/search/status`, {
                hasDefaultURL: false,
            });
            if (data) {

                for (var x in data) {
                    statusdata.push({ "value": data[x].fmStatusID, "label": data[x].fmStatusDesc });
                };
            };
        } catch (err) {
            setLoading(false);
        };
    };

    const fetchinvoicetype = async (e) => {
        setIsSelectAllChecked(false);
        setInvoiceid(e.target.value)
        var invoicetypeid = e.target.value;
        cleartabledata();
        setOptSelectedCE({ optionSelected: '-1' });
        fetchStartingYearMonth();
        fetchGetEndingYearMonth();
        setmaxmonth(new Date(endingyear, endingMonth, 28));
        setSelectedDate(new Date(endingyear, endingMonth - 1, 28))
        setSelectedYear(new Date(endingyear, 11, 28));
        SearchButton = true;
        if (invoicetypeid == 1) {
            fetchCoveredentity();
        }
        else {
            setCoveredentitydata([]);
        }
    };

    const handelYear = (date) => {
        if (!date) return "";
        setSelectedDate();
        setSelectedYear(date)
        const year = moment(new Date(date)).format("YYYY");
        setyear(year);
        let currentyear = new Date().getFullYear();
        let yearvalue = parseInt(year);
        if (currentyear === yearvalue) {
            fetchStartingYearMonth();
            fetchGetEndingYearMonth();
            setmaxmonth(new Date(endingyear, endingMonth, 28));
            setSelectedDate(new Date(endingyear, endingMonth, 28));
        }
        else {
            let monthdata = new Date(endingyear, 11, 28);
            setmaxmonth(monthdata)
            setSelectedDate(monthdata)
            setmonth(12);
        };
    };

    const formatMonth = (date) => {
        setSelectedDate();
        if (!date) return "";
        setSelectedDate(date)
        const options = { month: "long" };
        const month = moment(new Date(date)).format("MM");
        const monthint = parseInt(month)
        setmonth(monthint)
    };

    const reset = () => {
        fetchStartingYearMonth();
        fetchGetEndingYearMonth();
        setSelectedDate();
        setmaxmonth(new Date(endingyear, endingMonth, 28));
        setSelectedYear(new Date(endingyear, 11, 28));
        setIsSelectAllChecked(false);
        fetchStatus();
        setStatus(-1);
        setOptSelectedCE({ optionSelected: '-1' });
        SearchButton = true;
        onReset(true);
    };

    const handleCoverentityChange = (selected) => {
        let newSelectedOptions;

        if (selected && selected.some(option => option.value === 'selectAll')) {
            SearchButton = false;
            if (selectedOptionCE.optionSelected.length === coveredentitydata.length - 1) {
                newSelectedOptions = [];
                SearchButton = true;
            } else {
                newSelectedOptions = coveredentitydata.filter(option => option.value !== 'selectAll');
            }
        } else {
            newSelectedOptions = selected;
            if (selected.length == 0)
                SearchButton = true;
            else
                SearchButton = false;
        }
        setOptSelectedCE({ optionSelected: newSelectedOptions });
        const newManufactureIds = newSelectedOptions.map(option => option.value);
        setCoveredentitesIds(newManufactureIds);
        setIsSelectAllChecked(newSelectedOptions.length === coveredentitydata.length - 1);
    };

    const handelsetStatus = async (e) => {
        var statusvalue = e.target.value;
        setStatus(statusvalue);
    }

    const cancelmonth = async () => {
        setSelectedDate();
        setmonth(0);
    };

    const handleSubmit = async (val, actions) => {

        var selectedvalue = selectedDate;
        var Statusvalue;
        if (Status == "") {
            Statusvalue = -1
        }
        else {
            Statusvalue = Status;
        }
        let values = {}
        values.invoicetype = '1'
        let optCe = [];
        for (var x in selectedOptionCE.optionSelected) {
            var rw = selectedOptionCE.optionSelected[x];
            optCe.push(rw.value);
        };
        if (optCe > [0]) { values.optCe = optCe }
        values.Status = Statusvalue;
        values.year = yearvalue;
        values.month = monthid;
        await onSearch(values);
    };

    const handelBulkUpdates = async () => {
        await manvalBulk();
    };

    return (
        <Formik
            initialValues={''}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            children={(props) => {
                const { handleSubmit } = props;
                return (
                    <div>
                        <h5 className='f-15 text-primary font-weight-700'>
                            Invoices
                        </h5>
                        <Row sm={5}>
                            <Col md={2} sm={6} xs={6}>
                                {' '}
                                <FormGroup>
                                    <Label for='InvoicetypeID'>Invoice Type</Label>
                                    <Input
                                        type='select'
                                        onChange={(e) => {
                                            fetchinvoicetype(e);
                                        }}
                                        value={invoiceid}
                                    >
                                        {selectedinvoicetypeoptions.map((status) => {
                                            const { id, label } = status;
                                            return (
                                                <option key={id} value={id}>
                                                    {label}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={2} sm={6} xs={6}>
                                {' '}
                                <FormGroup>
                                    <Label for='CoveredEntityID'>Covered Entity</Label>
                                    <ReactSelect
                                        name='CoveredEntity'
                                        options={coveredentitydata}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        optionSelected={true}
                                        components={{
                                            Option: CustomOption, ValueContainer: LimitedChipsContainer
                                        }}
                                        isSearchable="true"
                                        onChange={handleCoverentityChange}
                                        value={selectedOptionCE.optionSelected}
                                        className='claim_info'
                                        maxMenuHeight={220}
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 99,
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                            })
                                        }}
                                        isSelectAllChecked={isSelectAllChecked}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2} sm={6} xs={6} className="datepicker_info" style={{ zIndex: 99 }}>
                                <FormGroup>
                                    <Label for='yearID'>Year</Label>
                                    <div id="text">
                                        <InputGroup onMouseLeave={handleMouseLeave}>
                                            <DatePicker
                                                id="startDate"
                                                selected={selectedyear}
                                                onChange={(date) => handelYear(date)}
                                                onKeyDown={(e) => e.preventDefault()}
                                                dateFormat="yyyy"
                                                minDate={new Date(Startingyear, 0, 1)}
                                                maxDate={new Date(endingyear, 11, 28)}
                                                showYearPicker
                                            />
                                            <InputGroupText
                                                onClick={() => handleDateClick("startDate")}
                                            >
                                                <img src={Calendar} alt='' />
                                            </InputGroupText>
                                        </InputGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={2} sm={6} xs={6} className="datepicker_info" style={{ zIndex: 99, marginLeft: "0px" }} id="text1"

                            >
                                <FormGroup>
                                    <Label>Month</Label>
                                    <div id="text" >
                                        <InputGroup onMouseLeave={handleMouseLeave}>
                                            <DatePicker
                                                id="endDate"
                                                onKeyDown={(e) => e.preventDefault()}
                                                selected={selectedDate}
                                                onChange={(date) => formatMonth(date)}
                                                maxDate={maxmont}
                                                dateFormat="MMMM"
                                                autoComplete="off"
                                                showMonthYearPicker
                                                style={{ width: "150px" }}
                                            />
                                            <InputGroupText
                                                onClick={() => handleDateClick("endDate")}
                                            >
                                                <img onClick={() => cancelmonth()} src={CancleIcon} alt='' />
                                                &nbsp;&nbsp;
                                                <img src={Calendar} alt='' />
                                            </InputGroupText>
                                        </InputGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={2} sm={3} xs={6} hidden={Statusdropdown == false}>
                                <FormGroup>
                                    <Label>Status</Label>
                                    <Input
                                        id="Status"
                                        name="Status"
                                        type='select'
                                        value={Status}
                                        onChange={(e) => {
                                            handelsetStatus(e);
                                        }}
                                    >
                                        <option value={''}>--Select--</option>
                                        {statusdata.map((status) => {
                                            const { value, label } = status;
                                            return (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="auto" className="pt-4 mt-1">
                                <Label>{""}</Label>
                                <Button
                                    color="primary"
                                    className="ms-2"
                                    onClick={handleSubmit}
                                    disabled={SearchButton}
                                >
                                    Search
                                </Button>
                                <Button
                                    color="primary"
                                    className="ms-2"
                                    onClick={() => reset()}
                                >
                                    Reset
                                </Button>
                                <Button
                                    color="primary"
                                    className="ms-2"
                                    onClick={handelBulkUpdates}
                                    hidden={Statusdropdown == false}
                                >
                                    Bulk Update
                                </Button>
                            </Col>
                        </Row>
                    </div>
                );
            }}
        ></Formik>
    );
};

export default SearchContainer;